module.exports = __webpack_public_path__ + "static/22-db73e15bd021579d33a0ccb32537344a.jpg";